export default "__VITE_ASSET__8e65922a__"